import { Component } from '@angular/core';
import { List, NotificationRecord } from '../../../../shared/models/notifications';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { Subscription } from 'rxjs';
import { SocketEventType, SocketService } from '../../../../services/socket.service';
import { ToastService } from '../../toasts/toast-service';

@Component({
  selector: 'app-notification',
  standalone: false,
  templateUrl: './notification.component.html'
})
export class NotificationComponent {

  notificationListModel: List = new List;
  notificationList: NotificationRecord[] = [];
  totalUnreadNotifications: number = 0;
  notificationList_opened: boolean = true;
  totalNotifications: number = 0;
  loading: boolean = false;
  subscribetions: Subscription[] = [];

  constructor(
    public router: Router,
    private authService: AuthenticationService,
    private socket: SocketService,
    public toastService: ToastService
  ) {
  }

  ngOnInit(): void {
    this.GetNotificationsList();
    this.subscribetions.push(
      this.socket.getDataStream<string>(SocketEventType.Notification)
        .subscribe(message => {
          console.log(message);
          if (message.data?.message) {
            this.totalUnreadNotifications += 1;
            this.toastService.show({ text: message.data?.message });
          }
        }))
  }

  ngOnDestroy(): void {
    this.subscribetions.forEach((item) => item.unsubscribe);
  }

  GetNotificationsList() {
    this.loading = true;
    let model = { ...this.notificationListModel };
    model.page += 1;
    this.authService.GetNotifiactions(model).subscribe((result) => {
      this.notificationList = this.notificationList.concat(result.data.list);
      this.totalNotifications = result.data.total;
      this.loading = false;

      if (model.page == 1 && result.data.count_unread > 0) {
        this.MarkAllAsRead();
      }
    })
  }

  MarkAllAsRead() {
    this.authService.MarkAllNotificationsAsRead().subscribe((result) => { })
  }

  getNextPage() {
    if (this.totalNotifications > this.notificationList.length) {
      this.notificationListModel.page += 1;
      this.GetNotificationsList();
    }
  }
}
